import { Reveal, Kicker } from "./motion";

const tiers = [
  {
    name: "site",
    label: "Per site",
    body: "A monthly platform fee for each venue. It covers Front of House, Back Office and Intelligence, updates included, no separate modules to buy.",
  },
  {
    name: "terminal",
    label: "Per POS terminal",
    body: "A small fee for each till you run. Add one for a pop-up weekend, take it off again after. You only pay for the terminals in service.",
  },
  {
    name: "addons",
    label: "Optional add-ons",
    body: "Node hardware and, in time, Connect. Chosen when you need them, never bundled in to pad a number.",
  },
];

export default function Pricing() {
  return (
    <section
      id="pricing"
      data-testid="pricing"
      className="px-6 md:px-12 py-28 md:py-40 border-t border-verlo/10 bg-[rgba(32,27,95,0.03)]"
    >
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <Kicker>How pricing works</Kicker>
          <h2 className="mt-6 font-display font-light text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.1] text-verlo max-w-3xl">
            Priced the way a restaurant is actually run
          </h2>
          <p className="mt-8 text-base md:text-lg text-verlo max-w-2xl">
            No tiers named after metals, no feature held hostage behind an upgrade. Pricing
            is built from three simple parts, so you can work out your own number before you
            ever speak to us.
          </p>
        </Reveal>

        <div className="mt-16 md:mt-24 grid md:grid-cols-3 gap-px bg-verlo/15 border border-verlo/15">
          {tiers.map((t, i) => (
            <Reveal
              key={t.name}
              delay={i * 0.08}
              className="bg-paper p-8 md:p-12"
              data-testid={`pricing-tier-${t.name}`}
            >
              <p className="font-display text-xl md:text-2xl text-brass mb-2">
                {String(i + 1).padStart(2, "0")}
              </p>
              <p className="font-display text-2xl md:text-3xl text-verlo mb-6">{t.label}</p>
              <p className="text-base leading-relaxed text-verlo">{t.body}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-10 text-sm text-verlo/50">
            Final numbers with your account manager, sized to your venue and how you trade.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
